import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "sedanFilled"
const SedanFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.75 15.375C7.682 15.375 8.438 16.131 8.438 17.063S7.682 18.75 6.75 18.75 5.063 17.994 5.063 17.063C5.063 16.13 5.818 15.375 6.75 15.375M17.625 15.375C18.557 15.375 19.313 16.131 19.313 17.063S18.557 18.75 17.625 18.75 15.938 17.994 15.938 17.063C15.938 16.13 16.693 15.375 17.625 15.375" />
          <path
            fillRule="evenodd"
            d="M12.36 9.188C13.232 9.188 14.074 9.508 14.726 10.088L17.106 12.203 20.062 12.43C21.122 12.512 21.977 13.264 22.232 14.25H21.376C21.065 14.25 20.813 14.502 20.813 14.813S21.064 15.375 21.375 15.375H22.313V16.5C22.313 17.225 21.725 17.813 21 17.813H19.945Q20.06 17.456 20.062 17.063C20.063 15.716 18.973 14.625 17.626 14.625S15.188 15.716 15.188 17.063Q15.19 17.456 15.305 17.813H9.07Q9.186 17.456 9.187 17.063C9.188 15.716 8.098 14.625 6.75 14.625S4.313 15.716 4.313 17.063Q4.315 17.456 4.43 17.813H3C2.275 17.813 1.688 17.225 1.688 16.5V15.375H2.25C2.56 15.375 2.813 15.123 2.813 14.813S2.56 14.25 2.25 14.25H1.688C1.688 12.904 2.778 11.813 4.124 11.813H4.642L6.223 10.23C6.891 9.563 7.798 9.188 8.743 9.188zM8.743 10.312C8.096 10.313 7.476 10.57 7.019 11.028L6.015 12.029 6.805 12.188H9.939V10.312zM11.063 12.189H15.396L13.979 10.928C13.533 10.532 12.957 10.314 12.359 10.313H11.064z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SedanFilledIcon
